/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcDtcFilesV1FileEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_DTC_FILES_V1_FILE_EVENT_ENTITY_NAME = 'exc.dtc.files.v1.FileEvent';
export const excDtcFilesV1FileEventEntity = new schema.Entity<ExcDtcFilesV1FileEvent>(EXC_DTC_FILES_V1_FILE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcDtcFilesV1FileEvent) => `${entity.metadata?.eventId}` });

